import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { JobProcedureService } from '../../../services/sections/job/job-procedure.service';
import { GlobalSettingsService } from '../../../services/ui/global-settings.service';
import { JobProcedureFormBypassRequestDetails } from '../../../models/jobProcedureFormBypassRequestDetails';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import { CompleteRequest } from '../../../models/completeRequest';
import {GenericModalComponent} from '../../generic-modal/generic-modal.component';

@Component({
  templateUrl: './reject-bypass-request.component.html',
  styleUrls: [
    './reject-bypass-request.component.scss',
    '../../stylesheets/job-actions.scss',
    '../../stylesheets/job-main.scss',
    '../../stylesheets/job-inputs.scss',
  ],
})
export class RejectBypassRequestComponent implements OnInit, AfterViewInit {
  @ViewChild('procedureFormBypassResponseModal') public procedureFormBypassResponseModal: GenericModalComponent;
  @ViewChild('procedureFormBypassResponseModalError') public procedureFormBypassResponseModalError: GenericModalComponent;
  public formModel: FormGroup;
  public jobProcedureFormBypassRequestDetails: JobProcedureFormBypassRequestDetails;
  public isLoading = false;
  public self = this;
  public readonly ButtonIcons = ButtonIcons;

  constructor(
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private jobProcedureService: JobProcedureService
  ) {}

  ngOnInit(): void {
    this.initializeData();
    this.initializeForm();
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
  }

  public submitComment(): void {
    GlobalSettingsService.isSecondaryLoaderLoading = true;

    const updateRequestModel: CompleteRequest = {
      isApproved: false,
      comment: this.formModel.get('comment')?.value,
    };

    this.jobProcedureService
        .updateJobProcedureFormBypassRequest(
            this.activatedRoute.snapshot.paramMap.get('token'),
            updateRequestModel
        )
        .subscribe(
            () => {
              GlobalSettingsService.isSecondaryLoaderLoading = false;
              this.procedureFormBypassResponseModal.open();
              this.isLoading = false;
            },
            () => {
              GlobalSettingsService.isSecondaryLoaderLoading = false;
              this.procedureFormBypassResponseModalError.open();
            }
        );
  }

  public closeProcedureFormBypassResponseModal(){
    this.procedureFormBypassResponseModal.hide();

    const parentUrl = this.router.url.split('/').slice(0, -1).join('/');
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([parentUrl]);
    });
  }

  private initializeData(): void {
    this.isLoading = true;
    this.jobProcedureFormBypassRequestDetails = this.activatedRoute.snapshot.data.procedureFormBypassDetails as JobProcedureFormBypassRequestDetails;
    this.isLoading = false;
  }

  private initializeForm(): void {
    this.formModel = new FormGroup({
      comment: new FormControl(null),
    });
  }
}
